import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { UserApi } from '../api';
import { AdalService } from '../service';
import { AdUser } from '../shared';
import { Observable } from 'rxjs';

@Component({
	selector: 'utility',
	templateUrl: 'utility.component.html'
})

export class UtilityComponent implements OnInit {
	private adUser;
	constructor(private router: Router, private adalService: AdalService, private userApi: UserApi) { }

	ngOnInit() {
		if (this.adalService.userInfo) {
			this.adUser = new AdUser(
				this.adalService.userInfo.profile.onprem_sid,
				this.adalService.userInfo.profile.upn,
				this.adalService.userInfo.profile.family_name,
				this.adalService.userInfo.profile.given_name,
				this.adalService.userInfo.profile.unique_name
			);
			this.userApi.getLogonUser(this.adUser)
				.subscribe(res => res);

			// this.userApi.getGroupMemberOf().subscribe(res => console.log(res));
		}
	}
	public get isLoggedIn() {
		return this.adalService.isAuthenticated;
	}
}
